import React, { useEffect, useRef } from "react";

const EDGE_INSET = 15;

const TabStrip = ({
  tabs,
  activeId,
  label = "Purchase type",
  variant = "tabs",
  onSelect,
}) => {
  const isRadio = variant === "radio";
  const stripRef = useRef(null);
  const tabRefs = useRef(new Map());

  useEffect(() => {
    const strip = stripRef.current;
    const tab = tabRefs.current.get(activeId);

    if (!strip || !tab) return;
    if (strip.scrollWidth <= strip.clientWidth) return;

    strip.scrollTo({
      left: Math.max(tab.offsetLeft - EDGE_INSET, 0),
      behavior: "smooth",
    });
  }, [activeId]);

  if (tabs.length <= 1 && !tabs.length) return null;

  return (
    <div
      className="sy-tabstrip"
      ref={stripRef}
      role={isRadio ? "radiogroup" : "tablist"}
      aria-label={label}
    >
      <div className="sy-tabstrip-track">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role={isRadio ? "radio" : "tab"}
            {...(isRadio
              ? { "aria-checked": tab.id === activeId }
              : { "aria-selected": tab.id === activeId })}
            ref={(node) => {
              if (node) tabRefs.current.set(tab.id, node);
              else tabRefs.current.delete(tab.id);
            }}
            className={`sy-tab${tab.id === activeId ? " is-active" : ""}`}
            onClick={() => onSelect(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default React.memo(TabStrip);
